import { ArrayUtils, engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { PaylinesSelector } from "../PaylinesSelector";
import { Paylines } from "../Paylines";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { StageController } from "../../Components/StageController";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { DataManager } from "../../Managers/DataManager";
import { MachineExtended } from "../../CustomComponents/MachineExtended";
import { WinAnimatorExtended } from "../../CustomComponents/WinAnimatorExtended";
import { TeasingExtended } from "../../CustomComponents/TeasingExtended";
import { Tweens } from "../../Components/Effects/Tweens";
import { BetManager } from "../../Managers/BetManager";
import { BaseView } from "../Base/BaseView";
import { AmbientBackground } from "../../Utils/AmbientBackground";

var WinType = Communication.Game.WinType;

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends ContainerElement {
    public static WinFrame0: SwitchElement;
    public static WinFrame1: SwitchElement;
    public static WinFrame2: SwitchElement;
    public static WinFrame3: SwitchElement;
    public static WinFrame4: SwitchElement;
    public static FsMessageBox: SwitchElement;

    private _controller: FreespinsController;

    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private startWinsDelay: FrameTimerEventEmitter;
    private startRecap: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _symbols: Symbols;
    private _machine: MachineExtended;
    private _winAnimator: WinAnimatorExtended;

    private _fsMessageStart: HTMLElement;
    private _fsMessageWonFsCount: HTMLElement;
    private _fsMessageEnd: HTMLElement;
    private _fsMessageEndNoWin: HTMLElement;

    private _teasingExtended: TeasingExtended;

    private _alphaArray: Array<any> = [];
    private _shakeAllArray: Array<any> = [];
    private _shakeAllArrayX: Array<number> = [];
    private _shakeAllArrayY: Array<number> = [];
    private _logoX: number;
    private _logoY: number;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this.startWinsDelay = CreateFrameTimer("startWinsDelay");
        this.startWinsDelay.on(FrameTimerEvents.Complete, this.showWins.bind(this));

        this.startRecap = CreateFrameTimer("startRecap");
        this.startRecap.on(FrameTimerEvents.Complete, this.startRecapSound.bind(this));

        StageController.freespinsStageContainer = this;

        this._teasingExtended = new TeasingExtended();
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                    this._paylines.reset();
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof MachineExtended) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimator) {
                    this._winAnimator = this.childs[key];
                }
            }

            this._fsMessageStart = document.getElementById("fsMessageStart");
            this._fsMessageWonFsCount = document.getElementById("fsMessageWonFsCount");
            this._fsMessageEnd = document.getElementById("fsMessageEnd");
            this._fsMessageEndNoWin = document.getElementById("fsMessageEndNoWin");

            if (DEBUG) {
                if (this._paylines == null) {
                    this.log("WARNING no paylines");
                }

                if (this._symbols == null) {
                    this.log("ERROR no symbols");
                }

                if (this._machine == null) {
                    this.log("ERROR no machine");
                }

                if (this._winAnimator == null) {
                    this.log("WARNING no winAnimator");
                }

                if (this._fsMessageStart == null) {
                    this.log("ERROR no fsMessageStart");
                }

                if (this._fsMessageEnd == null) {
                    this.log("ERROR no fsMessageEnd");
                }

                if (this._fsMessageEndNoWin == null) {
                    this.log("ERROR no fsMessageEndNoWin");
                }
            }

            if (this.childs["WinFrame0"] != null) FreespinsView.WinFrame0 = this.childs["WinFrame0"];
            if (this.childs["WinFrame1"] != null) FreespinsView.WinFrame1 = this.childs["WinFrame1"];
            if (this.childs["WinFrame2"] != null) FreespinsView.WinFrame2 = this.childs["WinFrame2"];
            if (this.childs["WinFrame3"] != null) FreespinsView.WinFrame3 = this.childs["WinFrame3"];
            if (this.childs["WinFrame4"] != null) FreespinsView.WinFrame4 = this.childs["WinFrame4"];
            if (this.childs["FsMessageBox"] != null) FreespinsView.FsMessageBox = this.childs["FsMessageBox"];
        }

        this._alphaArray.push(this.childs["PaylinesBackground"]);
        this._alphaArray.push(this.childs["SelectedPaylines"]);
        this._alphaArray.push(this.childs["NoWinContainer"]);
        this._alphaArray.push(this.childs["WinContainer"]);
        if (this.childs["Logo"] != null) {
            this._alphaArray.push(this.childs["Logo"]);
        }

        for (let i: number = 0; i < 5; i++) {
            if (this.childs["ReelBack" + i] != null) {
                this._alphaArray.push(this.childs["ReelBack" + i]);
            }
            if (this.childs["ReelBackMachine" + i] != null) {
                this._alphaArray.push(this.childs["ReelBackMachine" + i]);
            }
            if (this.childs["Reel" + i] != null) {
                this._alphaArray.push(this.childs["Reel" + i]);
            }
        }

        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = false;
            this._alphaArray[i].alpha = 0;
        }
    }

    disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
    }

    initReceived(controller: FreespinsController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            this._teasingExtended,
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.ChangeLevel, this.shakeAll.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.on(
                            WinAnimator.FinishQuickWinCalculation,
                            this.finishQuickWinCalculation.bind(this),
                        );
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this.childs["NoWinContainer"],
                            this.childs["WinContainer"],
                            true,
                        );
                    }
                    this._paylines.showPaylinesLabel();
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
        this.childs["PaylinesBackground"].goToCase("NORMAL" + (this.hasLineBet1() ? "_LINEBET1" : "_LINEBET5"));
    }

    initIntro(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = true;
            this._alphaArray[i].alpha = 1;
        }

        this._paylines.showPaylinesLabel();

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);

        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);

        this.visible = true;

        AmbientBackground.changeAmbientBackground("fs", 0);

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.play("SND_FSEnd");
            PlayList.loop("SND_FSWait");

            FreespinsView.FsMessageBox.goToCase("FS_END_SHOW");
            if (GameManager.freespinsResponse.totalWin > 0) {
                if (this._fsMessageEnd != null && this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
                    this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                }
            } else {
                if (
                    this._fsMessageEndNoWin != null &&
                    this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                ) {
                    this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                }
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
        this.hideMachineReels();
    }

    startRecapSound(): void {
        if (GameManager.freespinsResponse.totalWin > 0) {
            PlayList.loop("SND_BaseRecapLoop");
        } else {
            PlayList.loop("SND_FSEndLoop");
        }
    }

    spin(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        PlayList.stop("SND_BaseRecapLoop");

        if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        }

        if (
            this._fsMessageWonFsCount != null &&
            !this._fsMessageWonFsCount.classList.contains(HtmlController.DisabledClass)
        ) {
            this._fsMessageWonFsCount.classList.add(HtmlController.DisabledClass);
        }

        PlayList.loop("SND_FSLoop");
        this._machine.spinStart(this._winAnimator.reset(true, true), true, this._winAnimator.currentSymbols, -1);
        this.showMachineReels();
        this.resetShakeAll();
    }

    stop(): void {
        this._machine.spinStop(null, true);
    }

    startReceived(): void {
        if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        }
        BaseView.FsMessageBox.goToCase("FS_START_HIDE");

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    endReceived(): void {}

    onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
        this.hideMachineReel(this._machine.actualReelStopped);
    }

    machineStopped(): void {
        this._controller.machineStopped();
        this.showWins();
        this.hideMachineReels();
    }

    showWins(): void {
        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.stop("SND_FSLoop");
        }

        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                PlayList.stop("SND_FSLoop");
                PlayList.play("SND_FSEnd");
                PlayList.loop("SND_FSWait");
                this.startRecap.start(210);

                this.shakeAll(10);
                FreespinsView.FsMessageBox.goToCase("FS_END_SHOW");
                if (GameManager.freespinsResponse.totalWin > 0) {
                    if (
                        this._fsMessageEnd != null &&
                        this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)
                    ) {
                        this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                    }
                } else {
                    if (
                        this._fsMessageEndNoWin != null &&
                        this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                    ) {
                        this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                    }
                }
            }
        }
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        this._controller.allWinsFinished();

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.play("SND_FSEnd");
            PlayList.loop("SND_FSWait");
            this.startRecap.start(210);

            this.shakeAll(10);
            FreespinsView.FsMessageBox.goToCase("FS_END_SHOW");
            if (GameManager.freespinsResponse.totalWin > 0) {
                if (this._fsMessageEnd != null && this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
                    this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                }
            } else {
                if (
                    this._fsMessageEndNoWin != null &&
                    this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                ) {
                    this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                }
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
    }

    intro(long: boolean = false): void {
        StageController.freespinStage = true;
        this.resetShakeAll();
        this.visible = true;
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.reset(true);
        if (this.childs["Background"] != null) {
            this.childs["Background"].visible = true;
            this.childs["Background"].goToCase("NORMAL");
        }
        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = true;
            Tweens.removeTweens(this._alphaArray[i]);
            Tweens.alphaTween(this._alphaArray[i], {
                alphas: [0, 1],
                tweenDuration: 60,
            });
        }

        this._introDelay.start(60);
    }

    introFinished(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;
        if (this.childs["Background"] != null) {
            this.childs["Background"].visible = true;
        }
        this.visible = true;
        PlayList.loop("SND_FSLoop");
        this._controller.introFinished();
    }

    outro(): void {
        StageController.freespinStage = true;

        this.visible = true;
        this.startRecap.stop();

        AmbientBackground.changeAmbientBackground("base", 1500, 500);

        PlayList.stop("SND_FSLoop");
        PlayList.stop("SND_FSEndLoop");
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.stop("SND_FSWait", 30);
        PlayList.play("SND_FSTransition");

        FreespinsView.FsMessageBox.goToCase("FS_END_HIDE");
        if (this._fsMessageEnd != null && !this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageEnd.classList.add(HtmlController.DisabledClass);
        }

        if (
            this._fsMessageEndNoWin != null &&
            !this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
        ) {
            this._fsMessageEndNoWin.classList.add(HtmlController.DisabledClass);
        }

        this._winAnimator.reset(true, true);
        if (this.childs["Background"] != null) {
            this.childs["Background"].goToCase("TO_BASE");
        }
        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = true;
            Tweens.removeTweens(this._alphaArray[i]);
            Tweens.alphaTween(this._alphaArray[i], {
                alphas: [1, 0],
                tweenDuration: 30,
            });
        }
        this._outroDelay.start(150);
    }

    outroFinished(): void {
        StageController.freespinStage = false;
        if (this.childs["Background"] != null) {
            this.childs["Background"].visible = false;
        }

        this.visible = false;
        this._controller.outroFinished();
    }

    enable(): void {
        PlayList.play("SND_FSWin");
        // PlayList.loop('SND_FSWinLoop');
        PlayList.loop("SND_FSWait");

        if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
            BaseView.FsMessageBox.goToCase("FS_START_SHOW");
        }
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }

    selectPayline(id?: number): void {}

    updatePaylines(): void {
        if (this.childs["SelectedPaylines"] != null) {
            this.childs["SelectedPaylines"].goToCase(
                "SELECT_" + BetManager.PaylineCount + (this.hasLineBet1() ? "_LINEBET1" : "_LINEBET5"),
            );
        }
    }

    showMachineReels(): void {
        for (let i: number = 0; i < 5; i++) {
            if (this.childs["ReelBackMachine" + i] != null) {
                this.childs["ReelBackMachine" + i].visible = true;
            }
        }
    }

    hideMachineReel(index: number): void {
        if (this.childs["ReelBackMachine" + index] != null) {
            this.childs["ReelBackMachine" + index].visible = false;
        }
    }

    hideMachineReels(): void {
        for (let i: number = 0; i < 5; i++) {
            if (this.childs["ReelBackMachine" + i] != null) {
                this.childs["ReelBackMachine" + i].visible = false;
            }
        }
    }

    public shakeAll(delay: number = 0): void {
        if (BaseView.ShakeAllConf == null) {
            return;
        }

        if (this._shakeAllArray.length === 0) {
            if (this.childs["PaylinesBackground"] != null) {
                this._shakeAllArrayX.push(this.childs["PaylinesBackground"].x);
                this._shakeAllArrayY.push(this.childs["PaylinesBackground"].y);
                this._shakeAllArray.push(this.childs["PaylinesBackground"]);
            }
            if (this.childs["SelectedPaylines"] != null) {
                this._shakeAllArrayX.push(this.childs["SelectedPaylines"].x);
                this._shakeAllArrayY.push(this.childs["SelectedPaylines"].y);
                this._shakeAllArray.push(this.childs["SelectedPaylines"]);
            }
            if (this.childs["NoWinContainer"] != null) {
                this._shakeAllArrayX.push(this.childs["NoWinContainer"].x);
                this._shakeAllArrayY.push(this.childs["NoWinContainer"].y);
                this._shakeAllArray.push(this.childs["NoWinContainer"]);
            }
            if (this.childs["WinContainer"] != null) {
                this._shakeAllArrayX.push(this.childs["WinContainer"].x);
                this._shakeAllArrayY.push(this.childs["WinContainer"].y);
                this._shakeAllArray.push(this.childs["WinContainer"]);
            }
            if (this.childs["WinAnimator"] != null) {
                this._shakeAllArrayX.push(this.childs["WinAnimator"].x);
                this._shakeAllArrayY.push(this.childs["WinAnimator"].y);
                this._shakeAllArray.push(this.childs["WinAnimator"]);
            }
            for (let i: number = 0; i < 5; i++) {
                if (this.childs["ReelBack" + i] != null) {
                    this._shakeAllArrayX.push(this.childs["ReelBack" + i].x);
                    this._shakeAllArrayY.push(this.childs["ReelBack" + i].y);
                    this._shakeAllArray.push(this.childs["ReelBack" + i]);
                }
                if (this.childs["Reel" + i] != null) {
                    this._shakeAllArrayX.push(this.childs["Reel" + i].x);
                    this._shakeAllArrayY.push(this.childs["Reel" + i].y);
                    this._shakeAllArray.push(this.childs["Reel" + i]);
                }
            }
            if (this.childs["Logo"] != null) {
                this._logoX = this.childs["Logo"].x;
                this._logoY = this.childs["Logo"].y;
            }
        }

        this.resetShakeAll();

        for (let i: number = 0; i < this._shakeAllArray.length; i++) {
            Tweens.removeTweens(this._shakeAllArray[i]);
            Tweens.positionTween(this._shakeAllArray[i], {
                tweenX: [
                    this._shakeAllArray[i].x,
                    this._shakeAllArray[i].x,
                    this._shakeAllArray[i].x,
                    this._shakeAllArray[i].x,
                    this._shakeAllArray[i].x,
                    this._shakeAllArray[i].x,
                    this._shakeAllArray[i].x,
                ],
                tweenY: [
                    this._shakeAllArray[i].y,
                    this._shakeAllArray[i].y + BaseView.ShakeAllConf[0],
                    this._shakeAllArray[i].y + BaseView.ShakeAllConf[1],
                    this._shakeAllArray[i].y + BaseView.ShakeAllConf[2],
                    this._shakeAllArray[i].y + BaseView.ShakeAllConf[3],
                    this._shakeAllArray[i].y + BaseView.ShakeAllConf[4],
                    this._shakeAllArray[i].y,
                ],
                tweenDuration: 30,
                tweenDelay: delay,
            });
        }
        if (this.childs["Logo"] != null) {
            Tweens.removeTweens(this.childs["Logo"]);
            Tweens.positionTween(this.childs["Logo"], {
                tweenX: [
                    this.childs["Logo"].x,
                    this.childs["Logo"].x,
                    this.childs["Logo"].x,
                    this.childs["Logo"].x,
                    this.childs["Logo"].x,
                    this.childs["Logo"].x,
                    this.childs["Logo"].x,
                ],
                tweenY: [
                    this.childs["Logo"].y,
                    this.childs["Logo"].y + BaseView.ShakeAllConf[0],
                    this.childs["Logo"].y + BaseView.ShakeAllConf[1],
                    this.childs["Logo"].y + BaseView.ShakeAllConf[2],
                    this.childs["Logo"].y + BaseView.ShakeAllConf[3],
                    this.childs["Logo"].y + BaseView.ShakeAllConf[4],
                    this.childs["Logo"].y,
                ],
                tweenDuration: 30,
                tweenDelay: delay,
            });
        }
    }

    public resetShakeAll(): void {
        for (let i: number = 0; i < this._shakeAllArray.length; i++) {
            if (this._shakeAllArrayX[i] != null) {
                this._shakeAllArray[i].x = this._shakeAllArrayX[i];
            }
            if (this._shakeAllArrayY[i] != null) {
                this._shakeAllArray[i].y = this._shakeAllArrayY[i];
            }
        }
        if (this.childs["Logo"] != null) {
            if (this._logoX != null) {
                this.childs["Logo"].x = this._logoX;
            }
            if (this._logoY != null) {
                this.childs["Logo"].y = this._logoY;
            }
        }
    }

    hasLineBet1() {
        return BetManager.PaylineCounts.indexOf(1) !== -1;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/